import * as React from 'react';
import {GridColDef, GridColumnHeaderParams} from '@mui/x-data-grid';

export const SKU_COL_WIDTH = 1;
export const DESC_COL_WIDTH = 1.5;
export const GROUP_COL_WIDTH = 0.6;
export const COUNTS_COL_WIDTH = 0.6;

const renderCountsHeader = (params: GridColumnHeaderParams) => (
  <>
    <span className="col-header-label">{params.colDef.headerName}</span>
    <small className="col-header-unit">EA.</small>
  </>
);

export const ITEM_MASTER_GRID_COLUMNS: GridColDef[] = [
  {field: 'itemCode', headerName: 'SKU', sortable: false, flex: SKU_COL_WIDTH},
  {field: 'description', headerName: 'Description', sortable: false, flex: DESC_COL_WIDTH},
  {field: 'group', headerName: 'Group', sortable: false, flex: GROUP_COL_WIDTH},
  {field: 'palletCount', headerName: 'Pallets', sortable: false, flex: COUNTS_COL_WIDTH},
  {field: 'cartonCount', headerName: 'Cartons', sortable: false, flex: COUNTS_COL_WIDTH},
  {
    field: 'storedCount',
    headerName: 'Stored',
    sortable: false,
    flex: COUNTS_COL_WIDTH,
    renderHeader: renderCountsHeader
  },
  {
    field: 'allocatedCount',
    headerName: "Req'd",
    sortable: false,
    flex: COUNTS_COL_WIDTH,
    renderHeader: renderCountsHeader
  },
  {field: 'receivedCount', headerName: 'IB', sortable: false, flex: COUNTS_COL_WIDTH, renderHeader: renderCountsHeader},
  {
    field: 'onHoldCount',
    headerName: 'On Hold',
    sortable: false,
    flex: COUNTS_COL_WIDTH,
    renderHeader: renderCountsHeader
  },
  {
    field: 'damagedCount',
    headerName: "Dmg'd",
    sortable: false,
    flex: COUNTS_COL_WIDTH,
    renderHeader: renderCountsHeader
  },
  {
    field: 'availableCount',
    headerName: 'Avail.',
    sortable: false,
    flex: COUNTS_COL_WIDTH,
    renderHeader: renderCountsHeader
  }
];

export interface ItemMasterGridContent {
  id: number;
  itemCode: string;
  description: string;
  group?: string;
  palletCount?: number;
  cartonCount?: number;
  storedCount?: number;
  allocatedCount?: number;
  receivedCount?: number;
  onHoldCount?: number;
  damagedCount?: number;
  availableCount?: number;
}
